module.exports = __webpack_public_path__ + "img/c04_unitgalley_Normal_ua.8cc80074.webp";